import React from "react";
import { SummaryListItemIconBtn } from "components/SummaryListItem";

export const Title = ({ type, title, presentation, menu, ...rest }) => (
  <div className="d-flex flex-nowrap justify-between justify-content-between w-100  my-1 border-bottom border-bottom-1 border-bottom-solid  pb-1 mb-0">
    <div className="w-80 d-flex flex-column">
      <div className="fw-bolder text-truncate">{title}</div>
      <div className="text-truncate text-gray-400">{presentation}</div>
    </div>
    <div className="d-flex flex-nowrap w-20 h-auto">
      {menu?.map((item, key) => (
        <SummaryListItemIconBtn
          type={type}
          key={key}
          menuItem={item}
          {...rest}
          title={title}
        />
      ))}
    </div>
  </div>
);
